import { ModalState } from "core/state/modal/reducer";

export const getActiveModalName = ({ modal }: { modal: ModalState }): string =>
  modal.stack[0];
